import { render, staticRenderFns } from "./FormDataBuilderBlock.vue?vue&type=template&id=65454c09"
import script from "./FormDataBuilderBlock.vue?vue&type=script&lang=js"
export * from "./FormDataBuilderBlock.vue?vue&type=script&lang=js"
import style0 from "./FormDataBuilderBlock.vue?vue&type=style&index=0&id=65454c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports